var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{staticStyle:{"text-align":"center"}},[_vm._v(" ©2021 | "+_vm._s(_vm.domain)+" domain email panel ")])}
var staticRenderFns = []

export { render, staticRenderFns }